import { Box, Grid, Link, Paper, CircularProgress } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import React, { useState, useEffect } from 'react';
import useStyles from './styles';

interface IProps {
  pending: boolean;
  onSubmit: (username: string, password: string, callback: (result: any) => void) => void;
}

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://www.radishfiction.com/">
        Radish Media, Inc.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
};

const SignIn = (props: IProps) => {
  const classes = useStyles();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [usernameError, setUsernameError] = useState<boolean>(false);
  const [passwordError, setPasswordError] = useState<boolean>(false);

  const { pending, onSubmit } = props;

  const submit = () => {
    onSubmit(username, password, result => {
      if (result.errorCode === 'NO_USER_ERROR') {
        setUsernameError(true);
      } else if (result.errorCode === 'PASSWORD_MISMATCH_ERROR') {
        setPasswordError(true);
      }
    });
  };

  useEffect(() => {
    setUsernameError(false);
    setPasswordError(false);
  }, [username, password]);

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <img
              src="https://cdn.dev.radishfiction.com/featured/collection_image.c8e9819e60e39920116d50d9394c32eb.jpg"
              alt="Radish"
              width="40"
              height="40"
            />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <div className={classes.form}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="User Id"
              autoFocus
              value={username}
              onChange={e => setUsername(e.target.value)}
              error={usernameError}
              helperText={usernameError ? 'Please check your ID' : undefined}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              error={passwordError}
              helperText={passwordError ? 'The password is incorrect.' : undefined}
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  submit();
                }
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={pending || username.trim() === '' || password.trim() === ''}
              onClick={() => {
                submit();
              }}
            >
              {pending && <CircularProgress size={20} color="secondary" />}
              {!pending && 'Sign In'}
            </Button>
            <Box mt={5}>
              <Copyright />
            </Box>
          </div>
        </div>
      </Grid>
      <Grid item xs={false} sm={4} md={7}>
        <div className={classes.shine}>
          <div style={{ width: '100%', height: '100%' }} className={classes.image}></div>
        </div>
      </Grid>
    </Grid>
  );
};

export default SignIn;
